module.exports = __webpack_public_path__ + "files/1e6d82bcf40164046fb92656319731fe.svg";